import { createFileRoute } from "@tanstack/react-router";
import { Header } from "@/components/site/Header";
import { Hero } from "@/components/site/Hero";
import { Stats } from "@/components/site/Stats";
import { About } from "@/components/site/About";
import { Services } from "@/components/site/Services";
import { CtaBand } from "@/components/site/CtaBand";
import { Reviews } from "@/components/site/Reviews";
import { Footer } from "@/components/site/Footer";


export const Route = createFileRoute("/")({
  head: () => ({
    meta: [
      { title: "ARTBAZ — Rekonštrukcie, stavby a realizácie na kľúč | Trenčín" },
      {
        name: "description",
        content:
          "ARTBAZ — kompletné rekonštrukcie, stavby, kúpeľne a interiéry pod jednou strechou. Viac ako 300 realizácií, 8 rokov skúseností a ocenenia Orly stavebníctva.",
      },
      { property: "og:title", content: "ARTBAZ — Staviame s dôrazom na detail" },
      {
        property: "og:description",
        content:
          "Kompletné rekonštrukcie, stavby a realizácie pod jednou strechou. Precízna práca a výsledky, ktoré vydržia.",
      },
    ],
  }),
  component: Index,
});

function Index() {
  return (
    <div className="min-h-screen bg-background">
      <Header />
      <main>
        <Hero />
        <Stats />
        <About />
        <Services />
        <CtaBand />
        <Reviews />
      </main>
      <Footer />
    </div>
  );
}
